import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressFormat'
})
export class AddressFormatPipe implements PipeTransform {

  private addressFormatObject = {
    'default': {
      'address1': {
        'visibility': true,
        'order': 1
      },
      'address2': {
        'visibility': true,
        'order': 2
      },
      'address3': {
        'visibility': true,
        'order': 3
      },
      'city': {
        'visibility': true,
        'order': 4
      },
      'zip': {
        'visibility': true,
        'order': 5
      },
      'state': {
        'visibility': true,
        'order': 6
      },
      'country': {
        'visibility': true,
        'order': 7
      },
    },
    'Spain': {
      'address1': {
        'visibility': true,
        'order': 1
      },
      'address2': {
        'visibility': true,
        'order': 2
      },
      'address3': {
        'visibility': false,
        'order': 3
      },
      'city': {
        'visibility': true,
        'order': 4
      },
      'zip': {
        'visibility': true,
        'order': 5
      },
      'state': {
        'visibility': true,
        'order': 6
      },
      'country': {
        'visibility': true,
        'order': 7
      },
    },
    'India': {
      'address1': {
        'visibility': true,
        'order': 1
      },
      'address2': {
        'visibility': true,
        'order': 2
      },
      'address3': {
        'visibility': false,
        'order': 3
      },
      'city': {
        'visibility': true,
        'order': 4
      },
      'zip': {
        'visibility': true,
        'order': 5
      },
      'state': {
        'visibility': true,
        'order': 6
      },
      'country': {
        'visibility': true,
        'order': 7
      },
    }
  }

  transform(addressObject: any, country ): any {
    let addressDisplayArray = [{'visibility': true,
                                  'fieldName': 'address1' } ,
                                  {'visibility': true,
                                  'fieldName': 'address2' },
                                  {'visibility': true,
                                  'fieldName': 'address3' },
                                  {'visibility': true,
                                  'fieldName': 'city' },
                                   {'visibility': true,
                                  'fieldName': 'zip' },
                                  {'visibility': true,
                                  'fieldName': 'state' },
                                   {'visibility': true,
                                  'fieldName': 'country' }];
    let stringToReturnAddress = '';
    if (addressObject.address1 === '' && addressObject.address2 === '' && addressObject.address1 === '' &&
    addressObject.city === '' && addressObject.zip === '' && addressObject.state === '' && addressObject.country === ''  ) {
      return '-';
    }

    // default case
    if (country === '' || country === undefined) {
      country = 'default';
    }
      for (let fieldDisplayObject in this.addressFormatObject[country]) {
        if (this.addressFormatObject[country].hasOwnProperty(fieldDisplayObject)) {
          if (this.addressFormatObject[country][fieldDisplayObject]['visibility'] === true) {
            let temp = {
              'visibility': true,
              'fieldName': fieldDisplayObject
            }
            addressDisplayArray[this.addressFormatObject[country][fieldDisplayObject]['order'] - 1] =
            Object.assign( {}, temp);
          } else {
            let temp = {
              'visibility': false,
              'fieldName': fieldDisplayObject
            }
            addressDisplayArray[this.addressFormatObject[country][fieldDisplayObject]['order'] - 1] =
            Object.assign( {}, temp);
          }
        }
        }
    for (let i = 0 ; i < addressDisplayArray.length; i ++ ) {
      if (addressDisplayArray[i].visibility === true) {
        stringToReturnAddress += ' ' + this.getFieldFromAddressObjectIndex(addressObject, addressDisplayArray[i], country );
      }
    }
    return  stringToReturnAddress ;
  }

  getFieldFromAddressObjectIndex(addrssObj, arrayObject, country) {
    return addrssObj[arrayObject.fieldName];

  }

}


